export default "__VITE_ASSET__BLTxkTmN__"